
import React from 'react';
import TransparencyHeader from './TransparencySection/TransparencyHeader';
import TransparencyContent from './TransparencySection/TransparencyContent';

const TransparencySection = () => {
  return (
    <section className="py-12 md:py-16 bg-gradient-to-br from-blue-50 to-purple-50">
      <div className="container mx-auto px-4">
        <TransparencyHeader />
        <TransparencyContent />
      </div>
    </section>
  );
};

export default TransparencySection;
